<template>
  <el-dialog title="공지사항" :visible.sync="dialogVisible" :width="localWidth" :before-close="handleClose" :show-close="false" append-to-body :close-on-click-modal="true">
    <el-card class="inner-card">
      <div slot="header" class="clearfix left bold">
        <span>{{title}}</span>
      </div>
      <div class="text item">
        <stone-tui-viewer ref="viewer" :content="content" />
        <!-- <div v-html="replaceCarriageReturnToBr(content)"></div> -->
        <!-- <img v-for="img in imageList" :src="img.download_url" :key="img.file_seq" width="100%" />
        <ul>
          <li class="hand" v-for="file in fileList" :key="file.file_seq" @click="downloadFile(file.download_url)">{{file.file_name}}</li>
        </ul> -->
      </div>
    </el-card>
    <el-card class="inner-card" v-if="fileList && fileList.length > 0">
      <div class="text item">
        <!-- <img v-for="img in imageList" :src="img.download_url" :key="img.file_seq" width="100%" /> -->
        <ul>
          <li class="hand" v-for="file in fileList" :key="file.file_seq" @click="downloadFile(file.download_url)">{{file.file_name}}</li>
        </ul>
      </div>
    </el-card>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">닫기</el-button>
    </span>
  </el-dialog>
</template>

<script>

import common from '@/modules/common'
import StoneTuiViewer from '@/components/stone-tui-viewer'

export default {
  name: 'Notice',
  mixins: [common.mixins],
  components: {StoneTuiViewer},
  props: {
    width: {
      type: String,
      required: false,
      default: '50%'
    }
  },
  data () {
    return {
      dialogVisible: false,
      title: '',
      content: '',
      imageList: [],
      fileList: [],
      localWidth: this.width
    }
  },
  methods: {
    loadNoticeInfo (boardSeq) {
      this.initData()
      common.axios.get('/board/load/' + boardSeq)
        .then(response => {
          const result = response.data
          this.title = result.board.title
          this.content = result.board.content
          result.fileList.map(f => {
            if (f.file_type === 'IMAGE') {
              this.imageList.push(f)
            } else {
              this.fileList.push(f)
            }
          })
        })
    },
    handleClose () {
      this.dialogVisible = false
      // this.$nextTick(() => {
      //   this.initData()
      // })
    },
    initData () {
      this.title = ''
      this.content = ''
      this.imageList = []
      this.fileList = []
    }
  }
}

</script>

<style scoped>
.hand {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/components/Notice.vue